import request from '@/utils/request'
import axios from 'axios'

// 登陆
export function login(data) {
	return request({
		// url: '/Enterprise/login',
		url: 'Enterprise/qasLogin',
		method: 'post',
		data
	})
}

// 登陆
export function wechatLogin(data) {
	return request({
		url: '/Enterprise/wechatLogin',
		method: 'post',
		data
	})
}

// 忘记密码
export function forgetLogin(data) {
	return request({
		url: '/Enterprise/forget',
		method: 'post',
		data
	})
}

// 新用户注册
export function registerLogin(data) {
	return request({
		url: '/Enterprise/register',
		method: 'post',
		data
	})
}

// 短信验证码验证
export function checkSms(data) {
	return request({
		url: '/Enterprise/checkSms',
		method: 'post',
		data
	})
}

// 发送验证码
// export function smsSend(phoneNumber, randNumber, sign, type, openid) {
// 	return request({
// 		url: '/sendCode',
// 		method: 'post',
// 		params: {
// 			phoneNumber: phoneNumber,
// 			randNumber: randNumber,
// 			sign: sign,
// 			type: type,
// 			openid: openid
// 		}
// 	})
// }
export function smsSend(phoneNumber) {
	return request({
		url: '/api/v1/5b5bdc44796e8',
		method: 'POST',
		params: {
			mobile: phoneNumber,
			type: 3
		}
	})
}

// //验证码登录
// export function qaLawyerLogin(data) {
// 	return request({
// 		url: '/Enterprise/qasLogin',
// 		method: 'post',
// 		data
// 	})
// }
//验证码登录
export function qaLawyerLogin(data) {
	return axios({
		url: process.env.VUE_APP_BASE_API + '/api/v1/69255465cca2d',
		method: 'post',
		data
	})
}

//修改用户信息
export function qaChangePass(data) {
	return request({
		url: '/Enterprise/qaChangePass',
		method: 'post',
		data
	})
}

// 获取企业认证信息
export function enterpriseAuthInfo() {
	return request({
		url: '/Enterprise/Auth/enterpriseAuthInfo',
		method: 'post'
	})
}

// 退出登录
export function loginOut() {
	return request({
		url: '/Enterprise/loginOut',
		method: 'post'
	})
}

// 获取职位列表
// 因为请求慢 加了个随机数 看下效果
export function getRoutes() {
	const timestamp = new Date().getTime()
	return request({
		url: '/getRoutes?t=' + timestamp,
		method: 'post'
	})
}

// 获取权限列表
export function getAuthList(data) {
	return request({
		url: '/Auth/getAuthList',
		method: 'post',
		data
	})
}
// 查询是否存在邀请记录
export function checkInvitation(data) {
	return request({
		url: '/checkInvitation',
		method: 'post',
		data
	})
}

// 绑定微信 24.01.31
export function bindWx(data) {
	return request({
		url: '/Enterprise/bindWx',
		method: 'post',
		data
	})
}

// 获取当前账号的信息 24.01.31
export function getAccountInfo(data) {
	return request({
		url: '/Enterprise/getAccountInfo',
		method: 'post',
		data
	})
}

// 根据id获取协议详情 24.02.22
export function getAgreementInfo(data) {
	return request({
		url: '/Enterprise/getAgreementInfo',
		method: 'post',
		data
	})
}
